var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
(() => {
    angular
        .module('QMC.Aufgaben', [])
        .config(routes);
    routes.$inject = ['$locationProvider', '$stateProvider', '$urlRouterProvider', 'qmcBase'];
    function routes($locationProvider, $stateProvider, $urlRouterProvider, qmcBase) {
        $locationProvider.html5Mode({
            enabled: false,
            requireBase: false
        });
        $stateProvider
            .state('tasks', {
            url: '/tasks',
            templateUrl: qmcBase + '/Aufgaben/List',
            controller: 'AufgabenListController',
            controllerAs: 'vm',
            resolve: {
                data: [
                    () => {
                        console.log('Current State: Tasks');
                    }
                ]
            }
        })
            .state('tasksdetail', {
            url: '/tasks/:id',
            templateUrl: qmcBase + '/Aufgaben/List',
            controller: 'AufgabenListController',
            controllerAs: 'vm',
            resolve: {
                data: [
                    () => {
                        console.log('Current State: Tasks Detail');
                    }
                ]
            }
        });
    }
})();
var QMC;
(function (QMC) {
    var Task;
    (function (Task) {
        class HttpProvider {
            static configureHttpProvider($httpProvider) {
                // initialize get if not there
                if (!$httpProvider.defaults.headers.get) {
                    $httpProvider.defaults.headers.get = {};
                }
                // disable IE ajax request caching
                $httpProvider.defaults.headers.get['If-Modified-Since'] = 'Mon, 26 Jul 1997 05:00:00 GMT';
                // extra
                $httpProvider.defaults.headers.get['Cache-Control'] = 'no-cache';
                $httpProvider.defaults.headers.get['Pragma'] = 'no-cache';
            }
        }
        Task.HttpProvider = HttpProvider;
    })(Task = QMC.Task || (QMC.Task = {}));
})(QMC || (QMC = {}));
(() => {
    angular.module('QMC.Aufgaben')
        .config(['$httpProvider', QMC.Task.HttpProvider.configureHttpProvider]);
})();
var QMC;
(function (QMC) {
    var Task;
    (function (Task) {
        let TaskService = class TaskService extends QMC.Common.BaseService {
            constructor($http, $q) {
                super($http, $q);
                this.$http = $http;
                this.$q = $q;
                this.modulePath = '/Task';
            }
            getTaskList(maxDays) {
                return super.get(this.modulePath, { maxDays: maxDays }, (data) => {
                    return data;
                });
            }
            getTask(id) {
                return super.getItem(this.modulePath + '/' + id, {}, (data) => {
                    return data;
                });
            }
            getTaskWv() {
                return super.getItem(this.modulePath + '/WvModel', {}, (data) => {
                    return data;
                });
            }
            postTask(data) {
                return super.post(this.modulePath, data).then((d) => {
                    return d;
                });
            }
            putTask(id, data) {
                return super.put(this.modulePath + '/' + id, data).then((data) => {
                    return data;
                });
            }
            setFinishedState(id, finishedState, finishDate) {
                return super.put(this.modulePath + '/' + id + '/SetFinished/' + finishedState + "?finishDate=" + finishDate, null).then((data) => {
                    return data;
                });
            }
            deleteTask(id) {
                return super.delete(this.modulePath + '/' + id).then((data) => { return data; });
            }
        };
        TaskService = __decorate([
            QMC.Service('QMC.Aufgaben', 'AufgabenService'),
            QMC.Inject('$http', '$q')
        ], TaskService);
        Task.TaskService = TaskService;
    })(Task = QMC.Task || (QMC.Task = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Task;
    (function (Task) {
        let AufgabenListController = class AufgabenListController {
            /**
             * Creates an instance of AufgabenListController.
             * @param {TaskService} taskService
             * @param {any} $qui
             * @param {Klient.KlientService} clientService
             * @param {*} userService
             * @param {any} $state
             * @param {any} $scope
             * @param {any} $timeout
             * @param {Common.QmcLanguageService} lng
             * @param {Common.QmcPermissionService} permissionService
             *
             * @memberof AufgabenListController
             */
            constructor($location, taskService, $qui, clientService, userService, $state, $scope, $timeout, lng, permissionService) {
                this.$location = $location;
                this.taskService = taskService;
                this.$qui = $qui;
                this.clientService = clientService;
                this.userService = userService;
                this.$state = $state;
                this.$scope = $scope;
                this.$timeout = $timeout;
                this.lng = lng;
                this.permissionService = permissionService;
                ////// permissions
                this.ui = new QMC.Task.UserInterface();
                this.allowTableExport = false;
                this.finishedTaskDays = QMC.Common.UserSettingConstantsAndDefaults.FINISHEDTASKSDAYS;
                this.lastSearchDays = QMC.Common.UserSettingConstantsAndDefaults.FINISHEDTASKSDAYS;
                ////// Form
                this.ignoreTaskModalCloseAction = false;
                this.callbacks = { onNew: (form) => this.createTask(form), onEdit: (form) => this.updateTask(form) };
                $qui.init($qui.getSectionColor($location.path()), () => {
                    $qui.anonAvatar();
                    $qui.bindEvents();
                });
                if (document.getElementById("permissions").getAttribute("task").toLocaleLowerCase() !== "true") {
                    this.forbidden = true;
                    return;
                }
                this.initBase();
            }
            initBase() {
                //ObjectType: WorklistItem
                this.permissionService.getPermissionsByObjectTypes([840501, 840508]).then((data) => {
                    this.delete = data[0].delete;
                    this.new = data[0].new;
                    this.modify = data[0].modify;
                    this.allowTableExport = data[0].print;
                    this.permissions = { base: data[0], document: data[1] };
                    this.$timeout(() => {
                        this.init();
                    });
                    this.getWvs();
                    this.$qui.getTableAutoload(this.userService).then((ltd) => {
                        this.shouldLoadTableData = ltd;
                        this.userService.getUserSettings(["TASK.FINISHEDTASKSDAYS"]).then((data) => {
                            if (data[0].value !== "")
                                this.finishedTaskDays = parseFloat(data[0].value);
                            if (this.shouldLoadTableData) {
                                this.getData();
                                this.events();
                            }
                        });
                    });
                    this.$scope.$on('$locationChangeStart', () => {
                        // delete interval if page is left
                        clearInterval(this.interval);
                    });
                    if (this.$state.params.id !== (null || undefined)) {
                        this.editTask({ objectId: this.$state.params.id });
                        if (this.$state.history[0] && this.$state.history[0].name !== this.$state.current.name) {
                            $('#taskModal').on('hidden.bs.modal', () => {
                                if (!this.ignoreTaskModalCloseAction)
                                    this.goBack();
                            });
                        }
                    }
                });
            }
            getData() {
                this.getTasks();
            }
            /////////////// DISPLAY LOGIC ///////////////
            init() {
                if (QMC.Common.personalLocalStorage.getItem(QMC.Common.LocalStorageConstants.TASK_LIST_HIDE_FINISHED) !== null) {
                    this.hideFinished = QMC.Common.personalLocalStorage.getItem(QMC.Common.LocalStorageConstants.TASK_LIST_HIDE_FINISHED) === 'true';
                }
                this.promptOptions = {
                    title: "Aufgabe",
                    yesNo: true,
                    icon: "qm-icon-check",
                    text: ""
                };
            }
            events() {
                this.$scope.$watch('vm.finishedTaskDays', () => {
                    if (this.lastSearchDays !== this.finishedTaskDays && !this.loading) {
                        if (this.finishedTaskDays < 0)
                            this.finishedTaskDays = 0;
                        this.lastSearchDays = this.finishedTaskDays;
                        this.getTasks();
                    }
                });
            }
            goBack() {
                this.$state.go(this.$state.history[0].name, this.$state.history[0].params);
            }
            toggleShowFinished() {
                this.hideFinished = !this.hideFinished;
                QMC.Common.personalLocalStorage.setItem(QMC.Common.LocalStorageConstants.TASK_LIST_HIDE_FINISHED, this.hideFinished.toString());
            }
            /////////////// SERVICE FUNCTIONS ///////////////
            getTasks() {
                this.filteredList = [];
                this.tasks = [];
                this.loading = true;
                this.taskService.getTaskList(Math.round(this.finishedTaskDays)).then((data) => {
                    this.lastSearchDays = this.finishedTaskDays;
                    this.tasks = data;
                    this.loading = false;
                    this.filteredList = angular.copy(data);
                    if (this.hideFinished) {
                        this.filteredList = this.filteredList.filter((obj) => {
                            return obj.isFinished === false;
                        });
                    }
                    //format strings for card view:
                    for (const element of this.filteredList) {
                        if (!element.isFinished)
                            element.dateFinished = null;
                        if (element.priorityId !== null)
                            element.priorityString = this.lng.translate(20014013, 'Priorität') + ": " + element.priority;
                        //this.filteredList[i].dateCreatedString = this.lng.translate(20000063, 'Erstellt am') + ": " + moment(this.filteredList[i].dateCreated).format("DD.MM.YYYY");
                        if (element.isFinished)
                            element.dateFinishedString = this.lng.translate(20014015, 'Erledigt am') + ": " + moment(element.dateFinished).format("DD.MM.YYYY");
                        if (element.dateToFinishTill !== null)
                            element.dateToFinishString = this.lng.translate(20014009, 'Frist') + ": " + moment(element.dateToFinishTill).format("DD.MM.YYYY");
                        element.hideMod =
                            element.isUserAuthor && !element.isFinished;
                    }
                    this.ui.taskTable.data = this.filteredList;
                    this.$qui.functionWaiter("ui.createTable", this);
                    setTimeout(() => {
                        $(".action-padding-top").css('padding-top', '.25em');
                    }, 500);
                });
            }
            createTask(form) {
                if (form.participantIds === null || form.participantIds === undefined) {
                    form.participantIds = [];
                }
                this.loading = true;
                this.taskService.postTask(form).then(() => {
                    this.ui.notify(this.ui.successNote);
                    this.init();
                    this.getTasks();
                    this.loading = false;
                });
            }
            updateTask(task) {
                this.taskService.putTask(task.objectId, task).then((data) => {
                    this.ui.notify(this.ui.successNote);
                    this.getTasks();
                });
            }
            editTask(task) {
                this.loading = true;
                this.taskService.getTask(task.objectId).then((data) => {
                    data.participantIds = [];
                    data.participants.forEach(participant => {
                        data.participantIds.push(participant.id);
                    });
                    data.participants = data.participants.sort((a, b) => a.fullName.localeCompare(b.fullName));
                    data.taskDocumentObjectType = 840508;
                    this.formActions.open(data);
                    this.loading = false;
                });
            }
            deleteTask(item) {
                this.promptOptions.text = this.lng.translate(20000290, 'Wollen Sie den Eintrag wirklich löschen?');
                this.promptOptions.itemText = item.taskName;
                if ($('#taskModal').is(':visible')) {
                    this.ignoreTaskModalCloseAction = true;
                    $('#taskModal').modal('hide');
                    setTimeout(() => {
                        this.ignoreTaskModalCloseAction = false;
                    }, 500);
                }
                if (item.isFinished) {
                    QMC.Common.Utilities.confirm(this.promptOptions, (data) => {
                        if (data)
                            this.taskService.deleteTask(item.objectId).then(() => {
                                this.getTasks();
                                this.ui.notify(this.ui.deleteNote);
                                this.goBackMaybe();
                            });
                        else
                            this.goBackMaybe();
                    });
                }
                else {
                    QMC.Common.Utilities.confirm(this.promptOptions, (data) => {
                        if (data)
                            this.taskService.setFinishedState(item.objectId, true, moment(new Date()).format("DD.MM.YYYY").toString()).then(() => {
                                this.taskService.deleteTask(item.objectId).then(() => {
                                    this.getTasks();
                                    this.ui.notify(this.ui.deleteNote);
                                    $('#editTaskModal').unbind('hidden.bs.modal').off('hidden.bs.modal');
                                    this.goBackMaybe();
                                });
                            });
                        else
                            this.goBackMaybe();
                    });
                }
            }
            goBackMaybe() {
                if (this.$state.params.id !== (null || undefined)) {
                    if (this.$state.history[0] && this.$state.history[0].name !== this.$state.current.name) {
                        this.goBack();
                    }
                }
            }
            finishTask(form) {
                this.promptOptions.itemText = form.taskName;
                this.promptOptions.text = this.lng.translate(20014023, 'Aufgabe wirklich als erledigt markieren?');
                QMC.Common.Utilities.confirm(this.promptOptions, (data) => {
                    if (data)
                        this.taskService.setFinishedState(form.objectId, true, Date()).then(() => {
                            this.$qui.notify(this.$qui.successNote);
                            this.getTasks();
                        });
                });
            }
            undoTask(form) {
                this.promptOptions.itemText = form.taskName;
                this.promptOptions.text = this.lng.translate(20014025, 'Aufgabe wirklich zurücksetzen?');
                QMC.Common.Utilities.confirm(this.promptOptions, (data) => {
                    if (data)
                        this.taskService.setFinishedState(form.objectId, false, null).then(() => {
                            this.ui.notify(this.ui.successNote);
                            this.getTasks();
                        });
                });
            }
            getWvs() {
                this.taskService.getTaskWv().then((data) => {
                    this.wv = data;
                    const clients = [];
                    this.clientService.getAllPersonLists().then((data) => {
                        for (const element of data) {
                            clients.push({
                                value: element.objectId,
                                text: element.name + ' (' + this.lng.translate(20000292, 'Verteiler') + ')'
                            });
                        }
                        this.clientService.getEmployeeList().then((data) => {
                            for (const element of data) {
                                clients.push({
                                    value: element.objectId,
                                    text: element.displayTitle
                                });
                            }
                            this.maps = {
                                category: this.wv.categoryWvList.map((obj) => ({ value: obj.objectId, text: obj.name })),
                                priority: this.wv.priorityWvList.map((obj) => ({ value: obj.objectId, text: obj.name })),
                                executionType: this.wv.executionTypeWvList.map((obj) => ({ value: obj.objectId, text: obj.name })),
                                participant: clients,
                            };
                        });
                    });
                });
            }
        };
        AufgabenListController = __decorate([
            QMC.Controller('QMC.Aufgaben', 'AufgabenListController'),
            QMC.Inject('$location', 'AufgabenService', '$qui', 'KlientService', 'UserService', '$state', '$scope', '$timeout', 'QmcLanguageService', 'QmcPermissionService')
        ], AufgabenListController);
    })(Task = QMC.Task || (QMC.Task = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Task;
    (function (Task) {
        let TaskDirective = class TaskDirective {
            constructor(taskService, clientService, userService, $qui, lng, permissionService, $timeout) {
                this.taskService = taskService;
                this.clientService = clientService;
                this.userService = userService;
                this.$qui = $qui;
                this.lng = lng;
                this.permissionService = permissionService;
                this.$timeout = $timeout;
                this.restrict = 'E';
                this.templateUrl = './Aufgaben/';
                this.replace = true;
                this.scope = {
                    tasks: '@',
                    onCompleteTodo: '@',
                    forbidden: '@'
                };
                this.controller = ['$scope', (scope) => {
                        scope.ui = new Task.UserInterface();
                    }];
                this.link = (scope) => {
                    if (document.getElementById("permissions").getAttribute("task").toLocaleLowerCase() !== "true") {
                        scope.forbidden = true;
                        return;
                    }
                    scope.callbacks = { onNew: (form) => scope.createTask(form), onEdit: (form) => scope.updateTask(form) };
                    scope.vm = scope;
                    scope.forbidden = false;
                    scope.taskDocumentObjectType = '840508';
                    scope.objectType = '840501';
                    //ObjectType: WorklistItem
                    this.permissionService.getPermissionsByObjectTypes([scope.objectType, scope.taskDocumentObjectType]).then((data) => {
                        scope.deletePermission = data[0].delete;
                        scope.new = data[0].new;
                        scope.modify = data[0].modify;
                        scope.permissions = {
                            base: data[0],
                            document: data[1]
                        };
                    });
                    this.userService.getUserSettings(["TASK.FINISHEDTASKSDAYS"]).then((data) => {
                        scope.finishedTaskDays = "" ? scope.finishedTaskDays : parseFloat(data[0].value);
                        scope.tasks = scope.getTasks();
                    });
                    scope.promptOptions = {
                        title: "Aufgabe",
                        yesNo: true,
                        icon: "qm-icon-check",
                        text: this.lng.translate(20000290, 'Wollen Sie den Eintrag wirklich löschen?'),
                    };
                    scope.loading = true;
                    scope.onCompleteTodo = (item) => {
                        scope.putToFinish(item);
                    };
                    if (document.getElementById("permissions").getAttribute("task").toLocaleLowerCase() !== "true") {
                        console.log("No rights to see module task");
                        scope.forbidden = true;
                        return;
                    }
                    /////////////// DISPLAY LOGIC ///////////////
                    scope.getDetailModal = (obj) => {
                        scope.loading = true;
                        this.taskService.getTask(obj.objectId).then((data) => {
                            scope.selectedTask = data;
                            scope.selectedTask.participantIds = [];
                            if (scope.selectedTask.dateFinished)
                                scope.selectedTask.dateFinished = this.$qui.createDateFromString(scope.selectedTask.dateFinished);
                            else
                                scope.selectedTask.dateFinished = new Date();
                            data.participants.forEach(participant => {
                                scope.selectedTask.participantIds.push(participant.objectId);
                            });
                            scope.openEditModal();
                            scope.loading = false;
                        });
                    };
                    scope.openNewTaskModal = () => {
                        scope.formActions.new();
                    };
                    scope.openEditModal = () => {
                        const form = angular.copy(scope.selectedTask);
                        form.taskDocumentObjectType = 840508;
                        scope.formActions.open(form);
                    };
                    /////////////// SERVICE FUNCTIONS ///////////////
                    scope.createTask = (form) => {
                        if (form.participantIds === (null && undefined))
                            form.participantIds = [];
                        scope.loading = true;
                        this.taskService.postTask(form).then(() => {
                            this.$qui.notify(this.$qui.successNote);
                            scope.tasks = scope.getTasks();
                            scope.loading = false;
                        });
                    };
                    scope.updateTask = (task) => {
                        scope.loading = true;
                        this.taskService.putTask(task.objectId, task).then(() => {
                            this.$qui.notify(this.$qui.successNote);
                        }).finally(() => {
                            scope.loading = false;
                            scope.tasks = scope.getTasks();
                        });
                    };
                    scope.deleteTask = (task) => {
                        scope.promptOptions.text = this.lng.translate(20000290, 'Wollen Sie den Eintrag wirklich löschen?');
                        scope.promptOptions.itemText = task.taskName;
                        if (task.isFinished) {
                            QMC.Common.Utilities.confirm(scope.promptOptions, (data) => {
                                if (data) {
                                    scope.loading = true;
                                    this.taskService.deleteTask(task.objectId).then(() => {
                                        scope.tasks = scope.getTasks();
                                        this.$qui.notify(this.$qui.deleteNote);
                                    }).finally(() => {
                                        scope.loading = false;
                                    });
                                }
                            });
                        }
                        else {
                            QMC.Common.Utilities.confirm(scope.promptOptions, (data) => {
                                if (data) {
                                    scope.loading = true;
                                    this.taskService.setFinishedState(task.objectId, true, moment(new Date()).format("DD.MM.YYYY").toString()).then((data) => {
                                        this.taskService.deleteTask(task.objectId).then(() => {
                                            scope.tasks = scope.getTasks();
                                            this.$qui.notify(this.$qui.deleteNote);
                                        }).finally(() => {
                                            scope.loading = false;
                                        });
                                    });
                                }
                            });
                        }
                    };
                    scope.putToFinish = (item) => {
                        this.taskService.setFinishedState(item.objectId, item.isFinished, item.dateFinished).then((data) => {
                            this.$qui.notify(this.$qui.successNote);
                            scope.tasks = scope.getTasks();
                        });
                    };
                    scope.finishTask = (form) => {
                        scope.promptOptions.itemText = form.taskName;
                        scope.promptOptions.text = this.lng.translate(20014023, 'Aufgabe wirklich als erledigt markieren?');
                        QMC.Common.Utilities.confirm(scope.promptOptions, (data) => {
                            if (data)
                                this.taskService.setFinishedState(form.objectId, true, Date()).finally(() => {
                                    scope.tasks = scope.getTasks();
                                });
                        });
                    };
                    scope.undoTask = (form) => {
                        scope.promptOptions.text = this.lng.translate(20014025, 'Aufgabe wirklich zurücksetzen?');
                        scope.promptOptions.itemText = form.taskName;
                        QMC.Common.Utilities.confirm(scope.promptOptions, (data) => {
                            if (data)
                                this.taskService.setFinishedState(form.objectId, false, null).finally(() => {
                                    scope.tasks = scope.getTasks();
                                });
                        });
                    };
                    scope.getWvs = () => {
                        this.taskService.getTaskWv().then((wvData) => {
                            const clients = [];
                            this.clientService.getAllPersonLists().then((data) => {
                                for (const element of data) {
                                    clients.push({
                                        value: element.objectId,
                                        text: element.name + ' (' + this.lng.translate(20000292, 'Verteiler') + ')'
                                    });
                                }
                                this.clientService.getEmployeeList().then((data) => {
                                    for (const element of data) {
                                        clients.push({
                                            value: element.objectId,
                                            text: element.displayTitle
                                        });
                                    }
                                    scope.maps = {
                                        category: wvData.categoryWvList.map((obj) => ({ value: obj.objectId, text: obj.name })),
                                        priority: wvData.priorityWvList.map((obj) => ({ value: obj.objectId, text: obj.name })),
                                        executionType: wvData.executionTypeWvList.map((obj) => ({ value: obj.objectId, text: obj.name })),
                                        participant: clients,
                                    };
                                });
                            });
                        });
                    };
                    scope.getTasks = () => {
                        scope.loading = true;
                        return this.taskService.getTaskList(Math.round(scope.finishedTaskDays)).then((data) => {
                            scope.loading = false;
                            return data;
                        });
                    };
                    scope.getWvs();
                };
            }
        };
        TaskDirective = __decorate([
            QMC.Directive('QMC.Aufgaben', 'qmTasks', ['AufgabenService', 'KlientService', 'UserService', '$qui', 'QmcLanguageService', 'QmcPermissionService', '$timeout'])
        ], TaskDirective);
    })(Task = QMC.Task || (QMC.Task = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Task;
    (function (Task) {
        let TaskFormDirective = class TaskFormDirective {
            constructor($qui, $timeout, lng) {
                this.$qui = $qui;
                this.$timeout = $timeout;
                this.lng = lng;
                this.restrict = 'E';
                this.templateUrl = './Aufgaben/Form';
                this.replace = true;
                this.scope = {
                    permissions: '=',
                    callbacks: '&',
                    actions: '=',
                    modalId: '=?',
                    maps: '=?',
                    loading: '=?'
                };
                this.controller = ['$scope', (scope) => {
                        var _a;
                        scope.vm = scope;
                        scope.ui = new Task.UserInterface();
                        scope.modalId = (_a = scope.modalId) !== null && _a !== void 0 ? _a : 'taskModal_' + Math.random().toString(36).substr(2, 9);
                    }];
                this.link = (scope) => {
                    const initModal = () => {
                        $(`#${scope.modalId}`).modal('show');
                        if (!scope.maps) {
                            setTimeout(() => { initModal(); }, 500);
                            console.warn('No maps ready, can not create task form');
                            return;
                        }
                        this.$qui.functionWaiter('ui.createDirective', scope);
                        this.$qui.functionWaiter('ui.createForm', scope);
                        this.$qui.waitForEl(`#standardTabButton_${scope.modalId}`, () => {
                            $(`#standardTabButton_${scope.modalId}`).click();
                        });
                    };
                    scope.actions = {
                        open: (form) => {
                            scope.form = angular.copy(form);
                            scope.formState = 'edit';
                            initModal();
                        },
                        new: (form) => {
                            scope.formInvalid = true;
                            if (!form) {
                                const newGuidId = this.$qui.generateGuid();
                                form = {
                                    id: newGuidId,
                                    objectId: newGuidId,
                                    mainTaskId: newGuidId,
                                    objectType: 840501,
                                    taskDocumentObjectType: 840508,
                                    checked: false,
                                    isFinished: false,
                                    authorName: null,
                                    taskDescription: null,
                                    taskName: null,
                                    executionType: null,
                                    executionTypeId: QMC.Common.Constants.EXECUTION_TYPE_SINGLE_ID,
                                    dateCreated: new Date(),
                                    dateToFinishTill: null,
                                    dateFinished: null,
                                    categoryId: null,
                                    priorityId: null,
                                    priority: '',
                                    participantIds: [],
                                    participants: [],
                                    isUserAuthor: true
                                };
                                form.participantIds.push($('#session').data().personId);
                            }
                            scope.form = angular.copy(form);
                            scope.formState = 'new';
                            initModal();
                        }
                    };
                    scope.$watch('form', () => {
                        this.$timeout(() => {
                            scope.formInvalid = $(`#${scope.modalId}`).find(`#baseDataTab_${scope.modalId}`).find('.ng-invalid').length > 0;
                        });
                    }, true);
                    scope.getCategoryList = () => {
                        return scope.maps.category;
                    };
                    scope.getPriorityList = () => {
                        return scope.maps.priority;
                    };
                    scope.getExecutionTypeList = () => {
                        return scope.maps.executionType;
                    };
                    scope.getClients = () => {
                        return scope.maps.participant;
                    };
                    scope.onSave = (form, state) => {
                        if (state === 'new')
                            scope.callbacks().onNew(form);
                        if (state === 'edit')
                            scope.callbacks().onEdit(form);
                        $(`#${scope.modalId}`).modal('hide');
                    };
                    scope.getSingleFinishText = () => {
                        var _a, _b, _c;
                        if (((_a = scope.form) === null || _a === void 0 ? void 0 : _a.executionTypeId) === QMC.Common.Constants.EXECUTION_TYPE_SINGLE_ID && ((_c = (_b = scope.form) === null || _b === void 0 ? void 0 : _b.finishingPerson) === null || _c === void 0 ? void 0 : _c.id))
                            return this.$qui.formatString(this.lng.translate(20014033, 'Die Aufgabe wurde am {0} durch {1} erledigt.'), moment(scope.form.dateFinished).format('DD.MM.YYYY HH:mm'), scope.form.finishingPerson.name);
                        else
                            return '';
                    };
                };
            }
        };
        TaskFormDirective = __decorate([
            QMC.Directive('QMC.Aufgaben', 'qmTaskForm', ['$qui', '$timeout', 'QmcLanguageService'])
        ], TaskFormDirective);
    })(Task = QMC.Task || (QMC.Task = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Task;
    (function (Task) {
        /**
         * Task UserInterface class
         *
         * @export
         * @class UserInterface
         * @extends {Common.UserInterface}
         */
        class UserInterface extends QMC.Common.UserInterface {
            constructor() {
                super(...arguments);
                /**
                 * Task table
                 * @memberOf UserInterface
                 */
                this.taskTable = {
                    "config": {
                        "defaultSort": "dateToFinishTill",
                    },
                    "table": {
                        "Aufgabe": {
                            "label": "taskName",
                            "dType": "string",
                            "lngTag": "20014007",
                        },
                        "Frist": {
                            "label": "dateToFinishTill",
                            "dType": "Date",
                            "lngTag": "20014009",
                        },
                        "Autor": {
                            "label": "authorName",
                            "dType": "string",
                            "lngTag": "20000062",
                        },
                        "Erledigungstyp": {
                            "label": "executionType",
                            "dType": "string",
                            "lngTag": "20014014",
                        },
                        "Priorität": {
                            "label": "priority",
                            "dType": "string",
                            "lngTag": "20014013",
                        },
                        "Erledigt am": {
                            "label": "dateFinished",
                            "dType": "Date",
                            "lngTag": "20014015",
                        },
                        "Erledigt": {
                            "label": "isFinished",
                            "dType": "Bool",
                            "lngTag": "20000120",
                            "invisible": true
                        },
                        "Aktionen": [{
                                "icon": "qm-icon-check  green",
                                "click": "finishTask",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Als erledigt markieren",
                                "lngTag": "20014018",
                                "permission": "modify",
                                "events": {
                                    "hide": "isFinished",
                                },
                            }, {
                                "icon": "qm-icon-navigate_cross red",
                                "click": "undoTask",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Erledigung aufheben",
                                "lngTag": "20014024",
                                "permission": "modify",
                                "events": {
                                    "hide": "!isFinished",
                                },
                            }, {
                                "icon": "qm-icon-pencil blue",
                                "click": "editTask",
                                "label": "data",
                                "dType": "Button",
                                "openModal": "true",
                                "targetModal": "#taskModal",
                                "tooltip": "Bearbeiten",
                                "lngTag": "20000044",
                                "permission": "modify"
                            }, {
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteTask",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20000002",
                                "permission": "delete",
                                "events": {
                                    "hide": "!isUserAuthor"
                                }
                            }]
                    },
                    "card": {
                        "avatar": {
                            "icon": "fa qm-icon-clipboard_check_edit"
                        },
                        "text": {
                            "label": "taskName",
                            "dType": "string",
                            "lngTag": "20014007",
                        },
                        "subtext": [{
                                "label": "dateFinishedString",
                                "dType": "string",
                            }, {
                                "label": "executionType",
                                "dType": "string",
                            }, {
                                "label": "priorityString",
                                "dType": "string",
                            }, {
                                "label": "dateToFinishString",
                                "dType": "string"
                            }],
                        "toggle": {
                            "label": "isFinished"
                        },
                        "buttons": [{
                                "icon": "qm-icon-check  green",
                                "click": "finishTask",
                                "tooltip": "Als erledigt markieren",
                                "lngTag": "20014018",
                                "events": {
                                    "hide": "isFinished",
                                },
                            }, {
                                "icon": "qm-icon-navigate_cross red",
                                "click": "undoTask",
                                "tooltip": "Erledigung aufheben",
                                "lngTag": "20014024",
                                "events": {
                                    "hide": "!isFinished",
                                },
                            }, {
                                "icon": "qm-icon-pencil blue",
                                "click": "editTask",
                                "openModal": "true",
                                "targetModal": "#taskModal",
                                "tooltip": "Bearbeiten",
                                "lngTag": "20000044",
                            }, {
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteTask",
                                "permission": "delete",
                                "tooltip": "Löschen",
                                "lngTag": "20000002"
                            }]
                    },
                    "data": null,
                };
                /**
                 * Task form
                 * @memberOf UserInterface
                 */
                this.taskForm = {
                    form: [
                        {
                            label: "Aufgabe",
                            placeholder: "",
                            type: "String",
                            lngTag: "20014007",
                            required: true,
                            model: "taskName",
                            validate: {
                                message: "Bitte die Aufgabe angeben.",
                                messageTag: "20014008"
                            },
                            style: {
                                icon: "qm-icon-check",
                                class: "col-xs-12"
                            }
                        },
                        {
                            label: "Kategorie",
                            placeholder: "Kategorie auswählen",
                            type: "Select2",
                            lngTag: "20000137",
                            model: "categoryId",
                            dataSource: "getCategoryList",
                            style: {
                                class: "col-md-6 col-xs-12"
                            },
                            wvId: '87fc153c-3f3b-4746-9b45-c857f017cf2b',
                            wvListData: 'wv.categoryWvList'
                        },
                        {
                            label: "Priorität",
                            placeholder: "Priorität auswählen",
                            type: "Select2",
                            lngTag: "20014013",
                            model: "priorityId",
                            dataSource: "getPriorityList",
                            id: "priorityList",
                            style: {
                                class: "col-md-6 col-xs-12"
                            },
                            wvId: '4ffc823f-6619-4d38-a5ec-7d86a5e1d28a',
                            wvListData: 'wv.priorityWvList'
                        },
                        {
                            placeholder: "Erledigungstyp auswählen ...",
                            label: "Erledigungstyp",
                            type: "Select2",
                            lngTag: "20014014",
                            model: "executionTypeId",
                            dataSource: "getExecutionTypeList",
                            id: "executionTypeList",
                            required: true,
                            validate: {
                                message: "Bitte Erledigungstyp angeben.",
                                messageTag: "20014021"
                            },
                            style: {
                                class: "col-md-6 col-xs-12"
                            }
                        },
                        {
                            label: "Erledigungsfrist",
                            placeholder: "zu erledigen bis",
                            type: "Date",
                            model: "dateToFinishTill",
                            startDate: new Date(),
                            lngTag: "20014005",
                            style: {
                                icon: "fa fa-font",
                                class: "col-md-6 col-xs-12"
                            }
                        },
                        {
                            label: "Termin(e) verwenden",
                            type: "CheckboxInline",
                            model: "isAppointment",
                            id: "isAppointment",
                            lngTag: "20014030",
                            style: {
                                class: "col-md-6 col-xs-12"
                            },
                            events: {
                                hideExpression: "!(qmForm.dateToFinishTill)"
                            }
                        },
                        {
                            label: "Teilnehmer (Mitarbeiter)",
                            type: "Select2",
                            lngTag: "20014010",
                            model: "participantIds",
                            dataSource: "getClients",
                            multiple: true,
                            id: "participantsTypeList",
                            style: {
                                class: "col-xs-12"
                            }
                        },
                        {
                            label: "Beschreibung",
                            placeholder: "Beschreibung eintragen ...",
                            placeholderTag: '20014019',
                            type: "Summernote",
                            lngTag: "20014019",
                            model: "taskDescription",
                            style: {
                                class: "col-xs-12",
                            }
                        }
                    ],
                    actions: {
                        put: "updateTask",
                        post: "createTask",
                        delete: "deleteTask"
                    }
                };
            }
        }
        Task.UserInterface = UserInterface;
    })(Task = QMC.Task || (QMC.Task = {}));
})(QMC || (QMC = {}));

//# sourceMappingURL=../../maps/Task/qmc.task.js.map
